import { helper as buildHelper } from '@ember/component/helper';

const [currencyFormatter, currencyFormatterNoGrouping] = [true, false].map(
  (useGrouping) =>
    new Intl.NumberFormat('en-us', {
      style: 'currency',
      currency: 'USD',
      useGrouping,
    }),
);

/**
 *
 * @param amount
 * @param negativeParens
 * @param commas
 * @return {string}
 */
export const makeMoney = ([amount], { negativeParens = false, commas = true, inCents = false } = {}) => {
  const parsedNum = Number.parseFloat(amount);

  if (!Number.isFinite(parsedNum)) {
    return '$0.00';
  }

  const num = inCents
    ? parsedNum / 100
    : parsedNum;

  const formatter = commas
    ? currencyFormatter
    : currencyFormatterNoGrouping;

  let money = formatter.format(Math.abs(num));

  if (num < 0) {
    money = negativeParens
      ? `(${money})`
      : `-${money}`;
  }

  return money;
};

export default buildHelper(makeMoney);
